import { useContext ,useState} from 'react';

import { Container, Row} from 'react-bootstrap';

import classes from './main.component.module.scss';
import Login from '../loginTypes/Otp/Login';
import BiometricID from '../loginTypes/BiometricID';
import SmartCard from '../loginTypes/SmartCard';
import OldSmartCard from '../loginTypes/OldSmartCard';
import LoginContext from '../../store/login-context';
import { useEffect } from 'react';
import PassKey from '../loginTypes/PassKey/PassKey';
import PassKeyMarket from '../loginTypes/PassKey/PassKeyMarket';
import Account from '../loginTypes/Otp/Account/Account';
import PreLogin from '../loginTypes/Otp/LandingPageLogin/PreLogin/PreLogin';
import LandingPageLogin from '../loginTypes/Otp/LandingPageLogin/LandingPageLogin';


declare function Translate(key: string): string;
declare var _loginType: any;
declare var _loginTypeSMSOTP: any;
declare var _loginTypeWebAuthn: any;


const MainComponent = () => {

  const ctx = useContext(LoginContext);  

  
  useEffect(() => {
    const showBioId = sessionStorage.getItem('bioId');
    if (showBioId !== undefined  && showBioId === 'true'){
      sessionStorage.removeItem('bioId');
      ctx.bioIdSelected();
    }


    let isAccountView = sessionStorage.getItem('loginAccountView');
    if(isAccountView !== undefined && isAccountView === 'true'){
      sessionStorage.removeItem('loginAccountView');      
      ctx.toggleAccountView();
    }

  },[]);
        
  
  return (
    <div >
      <Container fluid>
        <div className={classes.up_note}>
          <div role="heading" aria-level={1} className={classes.title}>{Translate('N_Login_info_1')}</div>
          <div role="heading" aria-level={2} className={classes.subTitle}>{Translate('N_Login_Sub_Title')}</div>                        
        </div>
        <Row className={classes.main}>
          <div className={classes.sub_main}>                                  
          {_loginType === _loginTypeSMSOTP && 
            !ctx.isBioIdClicked && !ctx.isScClicked  && !ctx.isPassKeyMarket && !ctx.isAccount &&           
            <LandingPageLogin />
          }

          {_loginType === _loginTypeSMSOTP && 
            !ctx.isBioIdClicked && !ctx.isScClicked  && !ctx.isPassKeyMarket && ctx.isAccount && 
            <Account />
          }
                            
          {
            _loginType === _loginTypeWebAuthn && 
              !ctx.isBioIdClicked && !ctx.isScClicked && !ctx.isPassKeyMarket &&              
                <PassKey />                                  
          }

          {
            (ctx.isBioIdClicked) && 
              <BiometricID />
          }

          {
            ctx.isScClicked && !ctx.isOldCardProcess &&
              <SmartCard />
          }

          {
            ctx.isScClicked && ctx.isOldCardProcess &&
              <OldSmartCard />
          }
          
          {
            ctx.isPassKeyMarket &&              
              <PassKeyMarket />             
          }
          </div>
        </Row>        
      </Container>
    </div>
  );
};
export default MainComponent;

